<template>
  <div class="v3-widget v3-prow">
    <div
      v-for="(col, ci) in (cols || [])"
      :key="'c' + ci"
      class="v3-colblock"
      :style="{ gridColumn: 'span ' + spanFor(col) }"
    >
      <div
        v-for="(row, ri) in (col.rows || [])"
        :key="'r' + ci + '-' + ri"
        :id="tocId(ci, ri)"
        class="v3-anchor"
      >
        <LandingHero
          v-if="row.controlType === 'v3Hero'"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @addDocument="$emit('addDocument', $event)"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingStatRow
          v-else-if="row.controlType === 'v3StatRow'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
        />
        <LandingV3QuickLinks
          v-else-if="row.controlType === 'v3QuickLinks'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
        />
        <LandingV3DonutChart
          v-else-if="row.controlType === 'v3DonutChart'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @sessionExpired="$emit('sessionExpired', $event)"
        />
        <LandingV3BarChart
          v-else-if="row.controlType === 'v3BarChart'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @sessionExpired="$emit('sessionExpired', $event)"
        />
        <LandingV3FeedbackStrip
          v-else-if="row.controlType === 'v3FeedbackStrip'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
        />
        <LandingV3TaskList
          v-else-if="row.controlType === 'v3TaskList'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3TaskTable
          v-else-if="row.controlType === 'v3TaskTable'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3Delegated
          v-else-if="row.controlType === 'v3Delegated'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3Empty
          v-else-if="row.controlType === 'v3Empty'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @addDocument="$emit('addDocument', $event)"
        />
        <LandingV3AdminPriority
          v-else-if="row.controlType === 'v3AdminPriority'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3AttentionQueue
          v-else-if="row.controlType === 'v3AttentionQueue'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3Activity
          v-else-if="row.controlType === 'v3Activity'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3PriorityStack
          v-else-if="row.controlType === 'v3PriorityStack'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3ScoreRing v-else-if="row.controlType === 'v3ScoreRing'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <LandingV3LinkList v-else-if="row.controlType === 'v3LinkList'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <LandingV3FeatureTiles
          v-else-if="row.controlType === 'v3FeatureTiles'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @addDocument="$emit('addDocument', $event)"
        />
        <LandingV3DocList
          v-else-if="row.controlType === 'v3DocList'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3DocListFull
          v-else-if="row.controlType === 'v3DocListFull'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3ActionPanel
          v-else-if="row.controlType === 'v3ActionPanel'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @addDocument="$emit('addDocument', $event)"
        />
        <LandingV3Stepper v-else-if="row.controlType === 'v3Stepper'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <LandingV3CoachToast v-else-if="row.controlType === 'v3CoachToast'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <LandingV3Calibration
          v-else-if="row.controlType === 'v3Calibration'"
          :key="ri"
          :definition="row"
          :editMode="editMode"
          :qaActions="qaActions"
          @openDocument="$emit('openDocument', $event)"
        />
        <LandingV3Audit v-else-if="row.controlType === 'v3Audit'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <LandingV3Insights v-else-if="row.controlType === 'v3Insights'" :key="ri" :definition="row" :editMode="editMode" :qaActions="qaActions" />
        <!-- Nested layout container → recurse (carries a path so nested widget
             anchors stay globally unique; never a ToC root itself). -->
        <cLandingV3Renderer
          v-else-if="row.controlType === 'v3Group'"
          :cols="row.cols"
          :editMode="editMode"
          :qaActions="qaActions"
          :isRoot="false"
          :path="tocPath(ci, ri)"
          @addDocument="$emit('addDocument', $event)"
          @sessionExpired="$emit('sessionExpired', $event)"
          @openDocument="$emit('openDocument', $event)"
        />
        <div v-else class="v3-placeholder">
          <span>{{ row.title || row.controlType }} — not available in this engine</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LandingHero from "./cLandingHero";
import LandingStatRow from "./cLandingStatRow";
import LandingV3QuickLinks from "./cLandingV3QuickLinks";
import LandingV3DonutChart from "./cLandingV3DonutChart";
import LandingV3BarChart from "./cLandingV3BarChart";
import LandingV3FeedbackStrip from "./cLandingV3FeedbackStrip";
import LandingV3TaskList from "./cLandingV3TaskList";
import LandingV3TaskTable from "./cLandingV3TaskTable";
import LandingV3Delegated from "./cLandingV3Delegated";
import LandingV3Empty from "./cLandingV3Empty";
import LandingV3AdminPriority from "./cLandingV3AdminPriority";
import LandingV3AttentionQueue from "./cLandingV3AttentionQueue";
import LandingV3Activity from "./cLandingV3Activity";
import LandingV3PriorityStack from "./cLandingV3PriorityStack";
import LandingV3ScoreRing from "./cLandingV3ScoreRing";
import LandingV3LinkList from "./cLandingV3LinkList";
import LandingV3FeatureTiles from "./cLandingV3FeatureTiles";
import LandingV3DocList from "./cLandingV3DocList";
import LandingV3DocListFull from "./cLandingV3DocListFull";
import LandingV3ActionPanel from "./cLandingV3ActionPanel";
import LandingV3Stepper from "./cLandingV3Stepper";
import LandingV3CoachToast from "./cLandingV3CoachToast";
import LandingV3Calibration from "./cLandingV3Calibration";
import LandingV3Audit from "./cLandingV3Audit";
import LandingV3Insights from "./cLandingV3Insights";
import { useHomeToc } from "@/composables/useHomeToc";

// Icon + fallback label per v3 widget for the "On this page" ToC. The widget's
// own `title` wins when set; the icon mirrors the widget's rail/prototype glyph.
const TOC_META = {
  v3Hero: { icon: "rocket_launch", label: "Overview" },
  v3StatRow: { icon: "insights", label: "At a glance" },
  v3QuickLinks: { icon: "grid_view", label: "Quick links" },
  v3DonutChart: { icon: "donut_large", label: "Progress" },
  v3BarChart: { icon: "bar_chart", label: "Distribution" },
  v3FeedbackStrip: { icon: "forum", label: "Feedback" },
  v3TaskList: { icon: "checklist", label: "My Tasks" },
  v3TaskTable: { icon: "table_rows", label: "All Tasks" },
  v3Delegated: { icon: "send", label: "My Delegations" },
  v3Empty: { icon: "inbox", label: "Nothing to do" },
  v3AdminPriority: { icon: "priority_high", label: "All Priorities" },
  v3AttentionQueue: { icon: "rate_review", label: "All Reviews" },
  v3Activity: { icon: "history", label: "Recent activity" },
  v3PriorityStack: { icon: "priority_high", label: "My Priorities" },
  v3ScoreRing: { icon: "donut_small", label: "Score" },
  v3LinkList: { icon: "list", label: "Links" },
  v3FeatureTiles: { icon: "dashboard", label: "Features" },
  v3DocList: { icon: "history_toggle_off", label: "Recent jobs" },
  v3DocListFull: { icon: "table_chart", label: "Documents table" },
  v3ActionPanel: { icon: "bolt", label: "Actions" },
  v3Stepper: { icon: "linear_scale", label: "Progress" },
  v3CoachToast: { icon: "tips_and_updates", label: "Tip" },
  v3Calibration: { icon: "balance", label: "Calibration" },
  v3Audit: { icon: "verified_user", label: "Audit readiness" },
  v3Insights: { icon: "query_stats", label: "Anomalies & insights" },
};

// Recursive renderer for the new (v3) engine — mirrors the beta HomeRowBlock.
// Renders a set of columns (each with stacked rows); a `v3Group` row is itself
// a set of columns, so layouts nest to any depth.
export default {
  name: "cLandingV3Renderer",
  components: { LandingHero, LandingStatRow, LandingV3QuickLinks, LandingV3DonutChart, LandingV3BarChart, LandingV3FeedbackStrip, LandingV3TaskList, LandingV3TaskTable, LandingV3Delegated, LandingV3Empty, LandingV3AdminPriority, LandingV3AttentionQueue, LandingV3Activity, LandingV3PriorityStack, LandingV3ScoreRing, LandingV3LinkList, LandingV3FeatureTiles, LandingV3DocList, LandingV3DocListFull, LandingV3ActionPanel, LandingV3Stepper, LandingV3CoachToast, LandingV3Calibration, LandingV3Audit, LandingV3Insights },
  props: {
    cols: { type: Array, default: () => [] },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
    // Only the ROOT renderer publishes the "On this page" ToC.
    isRoot: { type: Boolean, default: true },
    // Path prefix so nested (v3Group) widget anchors stay globally unique.
    path: { type: String, default: "" },
  },
  methods: {
    spanFor(col) {
      const n = (this.cols || []).length || 1;
      return col && col.cols >= 1 && col.cols <= 12 ? col.cols : Math.max(1, Math.floor(12 / n));
    },
    // Anchor id for the widget wrapper at (col, row) within this renderer's path.
    tocId(ci, ri) {
      return `home-w-${this.path}${ci}_${ri}`;
    },
    // Path handed to a nested v3Group renderer (extends this one's path).
    tocPath(ci, ri) {
      return `${this.path}${ci}_${ri}-`;
    },
    // Walk the columns (recursing into v3Groups) → flat ToC entry list, ids
    // matching the rendered wrapper anchors exactly.
    buildToc(cols, path) {
      const out = [];
      (cols || []).forEach((col, ci) => {
        (col.rows || []).forEach((row, ri) => {
          const ct = row && row.controlType;
          if (!ct || !ct.startsWith("v3") || ct === "v3Empty") return;
          if (ct === "v3Group") {
            out.push(...this.buildToc(row.cols, `${path}${ci}_${ri}-`));
            return;
          }
          const meta = TOC_META[ct] || { icon: "chevron_right", label: ct };
          out.push({
            id: `home-w-${path}${ci}_${ri}`,
            label: (row.title && String(row.title).trim()) || meta.label,
            icon: meta.icon,
          });
        });
      });
      return out;
    },
    publishToc() {
      if (!this.isRoot || this.editMode) return;
      useHomeToc().setEntries(this.buildToc(this.cols, ""));
    },
  },
  watch: {
    cols: { handler() { this.publishToc(); }, deep: true },
  },
  mounted() {
    this.publishToc();
  },
  beforeDestroy() {
    if (this.isRoot) useHomeToc().clear();
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
